/* Review "Paid X" amounts. PRICE TEST (Oct 2026):
        1 mask 26.95 · 2 masks 46.95 · 3 masks 61.95
        + goggles 22.95 → 49.90 · 69.90 · 84.90
   Picked per review from a hash of name + title, so it never changes between
   visits. Shown in the REVIEWER's currency, rounded up to .95. */
(function(){
var POOL=[[46.95,36],[61.95,22],[26.95,20],[69.90,10],[49.90,6],[84.90,6]];
var TOTAL=0;POOL.forEach(function(p){TOTAL+=p[1];});
function hash(s){var h=2166136261;for(var i=0;i<s.length;i++){h^=s.charCodeAt(i);h=Math.imul(h,16777619);}return (h>>>0);}
function pick(key,text){
var t=(text||'').toLowerCase();
if(/single|full price|price drop|before a sale|before spotting|bundle (offer|deal|discount)|promo/.test(t))return 26.95;
if(/gifted three|brought three|bought three|all three|three more|3-pack|three of/.test(t))return 61.95;
var r=hash(key)%TOTAL;
for(var i=0;i<POOL.length;i++){if(r<POOL[i][1])return POOL[i][0];r-=POOL[i][1];}
return 46.95;
}
var CUR={'united states':'USD','canada':'CAD','united kingdom':'GBP','australia':'AUD','switzerland':'CHF','norway':'NOK','germany':'EUR','france':'EUR','austria':'EUR','ireland':'EUR','italy':'EUR','spain':'EUR','portugal':'EUR','netherlands':'EUR','belgium':'EUR','finland':'EUR'};
var RATE={USD:1,CAD:1.37,GBP:0.76,AUD:1.52,CHF:0.81,NOK:10.6,EUR:0.88};
var VC='USD',VR=1;
try{if(window.Shopify&&Shopify.currency){VC=Shopify.currency.active||'USD';VR=parseFloat(Shopify.currency.rate)||1;}}catch(e){}
if(VC&&VR)RATE[VC]=VR;
function currencyFor(loc){var l=(loc||'').toLowerCase().trim();var parts=l.split(',');var country=parts[parts.length-1].trim();return CUR[country]||'USD';}
var FMT={};
function fmt(c){if(!FMT[c]){try{FMT[c]=new Intl.NumberFormat('en-US',{style:'currency',currency:c,currencyDisplay:'narrowSymbol'});}catch(e){try{FMT[c]=new Intl.NumberFormat('en-US',{style:'currency',currency:c});}catch(e2){FMT[c]=null;}}}return FMT[c];}
function show(usd,c){if(c==='USD')return '$'+usd.toFixed(2);var raw=usd*(RATE[c]||1),out=Math.floor(raw)+0.95;if(out<raw)out+=1;var label=(c==='CAD')?'CA$':(c==='AUD')?'A$':null;if(label)return label+out.toFixed(2);var f=fmt(c);return f?f.format(out):(c+' '+out.toFixed(2));}
var TEXT_FIX=[
['Best twenty eight dollars I have spent on a season','Best money I have spent all season'],
['Best thirty dollars I have spent on a season','Best money I have spent all season'],
['Best forty dollars I have ever spent on a laugh','Best money I have ever spent on a laugh']
];
function run(){
var items=document.querySelectorAll('.ifri');
for(var i=0;i<items.length;i++){
var it=items[i];
if(it.getAttribute('data-if-paid2'))continue;
var pp=it.querySelector('.ifpp');
if(!pp)continue;
var nm=(it.querySelector('.ifnm')||{}).textContent||'';
var ti=(it.querySelector('.ifrc h4')||{}).textContent||'';
var lo=(it.querySelector('.iflo')||{}).textContent||'';
var bd=it.querySelector('.ifrc p');
if(bd){var bt=bd.textContent;TEXT_FIX.forEach(function(f){if(bt.indexOf(f[0])>-1)bt=bt.split(f[0]).join(f[1]);});if(bt!==bd.textContent)bd.textContent=bt;}
var usd=pick(nm+'|'+ti,ti+' '+(bd?bd.textContent:''));
var tn=pp.firstChild;
if(tn&&tn.nodeType===3){tn.nodeValue='Paid '+show(usd,currencyFor(lo))+' by ';}
it.setAttribute('data-if-paid2','1');
}
}
function watch(){var list=document.getElementById('iflist');if(!list)return false;if(!list.getAttribute('data-if-pw')){list.setAttribute('data-if-pw','1');if(window.MutationObserver)new MutationObserver(run).observe(list,{childList:true,subtree:true});}run();return true;}
var n=0;
var iv=setInterval(function(){n++;run();if((watch()&&n>8)||n>80)clearInterval(iv);},150);
if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
})();
